import createDataContext from "./createDataContext";
// import baseURL from "../api.js";
import dummyData from "../components/property/testData";

// var axios = require("axios");
// var qs = require("qs");

const getTotal = (arr, key) => {
  return arr.reduce((a, b) => a + (b[key] || 0), 0);
};

const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const reducer = (state, action) => {
  switch (action.type) {
    case "add_cart":
      
      action.payload.cartItem.finalBalanceCheck = (
        typeof action.payload.cartItem.customPaymentOption !== 'undefined' &&
        typeof action.payload.cartItem.customPaymentOption !== null &&
        action.payload.cartItem.customPaymentOption
        ? action.payload.cartItem.customPaymentOption 
        : action.payload.cartItem.balance
      );

      // console.log('cart item', action.payload.cartItem);

      // action.payload.cartItem.customBalance = (action.payload.cartItem.invoiceID == 158823941) ? 50 : action.payload.cartItem.balance;
      let applyInvoicePaymentObject = {
        invoiceId: action.payload.cartItem.invoiceID,
        amount: action.payload.cartItem.finalBalanceCheck
      }
      // action.payload.cartItem.invoiceID + ' : ' + action.payload.cartItem.customPaymentOption,
      
      return {
        ...state,
        shoppingCart: [...state.shoppingCart, action.payload.cartItem],
        invoices: [...state.invoices, action.payload.invoiceID],
        accountNumbers: [
          ...state.accountNumbers,
          action.payload.cartItem.account,
        ],
        owners: [
          ...state.owners,
          action.payload.cartItem.ownerName,
        ],
        applyInvoicePayment: [
          ...state.applyInvoicePayment,
          applyInvoicePaymentObject
        ],
        address1: [
          ...state.address1,
          action.payload.cartItem.address1,
        ],
        address2: [
          ...state.address2,
          action.payload.cartItem.address2,
        ],
        city: [
          ...state.city,
          action.payload.cartItem.city,
        ],
        state: [
          ...state.state,
          action.payload.cartItem.state,
        ],
        zipcode: [
          ...state.zipcode,
          action.payload.cartItem.zipcode,
        ],
        invoiceDependencyRemoved: false,
        total: numberWithCommas(
          getTotal(
            [...state.shoppingCart, action.payload.cartItem],
            "finalBalanceCheck"
          ).toFixed(2)
        ),
      };
    case "remove_from_cart":

      let filterApplyInvoicePayment = state.applyInvoicePayment.filter((item) => {
        return action.payload.invoices.includes(item.invoiceId);
      });
   
      return {
        ...state,
        shoppingCart: action.payload.shoppingCart,
        invoices: action.payload.invoices,
        accountNumbers: action.payload.accountNumbers,
        owners: action.payload.owners,
        address1: action.payload.address1,
        address2: action.payload.address2,
        city: action.payload.city,
        state: action.payload.state,
        zipcode: action.payload.zipcode,
        invoiceDependencyRemoved: action.payload.invoiceDependencyRemoved,
        applyInvoicePayment: filterApplyInvoicePayment,
        total: numberWithCommas(
          getTotal(action.payload.shoppingCart, "finalBalanceCheck").toFixed(2)
        ),
      };
    case "set_cart_visible":
      return {
        ...state,
        cartVisible: action.payload,
        invoiceDependencyRemoved: false,
      };
    case "set_invoice_dependency_removed":
      return {
        ...state,
        invoiceDependencyRemoved: action.payload,
      };
    case "disable_add_to_cart":
      return {
        ...state,
        disableCart: action.payload,
      };
    default:
      return state;
  }
};

const addToCart = (dispatch) => async (cartItem) => {
  let invoiceID = cartItem.invoiceID;

  dispatch({
    type: "add_cart",
    payload: { cartItem, invoiceID },
  });
};



const removeFromCart = (dispatch) => async ({ cartItem, cart, all }) => {
  if (all) {
    dispatch({
      type: "remove_from_cart",
      payload: { shoppingCart: [], invoices: [], accountNumbers: [], owners: [], address1: [], address2: [], city: [], state: [], zipcode: [], applyInvoicePayment: [] },
    });
    return;
  }


  let invoices = cart
    .filter((item) => {
      return item.invoiceID !== cartItem.invoiceID && item.controlInvoicesRequiredFirst.includes(cartItem.invoiceID) === false;
    })
    .map((obj) => {
      return obj.invoiceID;
    });


  let accountNumbers = cart
    .filter((item) => {
      return item.invoiceID !== cartItem.invoiceID && item.controlInvoicesRequiredFirst.includes(cartItem.invoiceID) === false;
    })
    .map((obj) => {
      return obj.account;
    });

  // console.log("ACCOUNT NUMBERS", cart);

  let owners = cart
    .filter((item) => {
      return item.invoiceID !== cartItem.invoiceID && item.controlInvoicesRequiredFirst.includes(cartItem.invoiceID) === false;
    })
    .map((obj) => {
      return obj.ownerName;
    });

  let address1 = cart
    .filter((item) => {
      return item.invoiceID !== cartItem.invoiceID && item.controlInvoicesRequiredFirst.includes(cartItem.invoiceID) === false;
    })
    .map((obj) => {
      return obj.address1;
    });


  let address2 = cart
    .filter((item) => {
      return item.invoiceID !== cartItem.invoiceID && item.controlInvoicesRequiredFirst.includes(cartItem.invoiceID) === false;
    })
    .map((obj) => {
      return obj.address2;
    });

  let city = cart
    .filter((item) => {
      return item.invoiceID !== cartItem.invoiceID && item.controlInvoicesRequiredFirst.includes(cartItem.invoiceID) === false;
    })
    .map((obj) => {
      return obj.city;
    });

  let state = cart
    .filter((item) => {
      return item.invoiceID !== cartItem.invoiceID && item.controlInvoicesRequiredFirst.includes(cartItem.invoiceID) === false;
    })
    .map((obj) => {
      return obj.state;
    });


  let zipcode = cart
    .filter((item) => {
      return item.invoiceID !== cartItem.invoiceID && item.controlInvoicesRequiredFirst.includes(cartItem.invoiceID) === false;
    })
    .map((obj) => {
      return obj.zipcode;
    });


  // console.log("OWNERS", owners);

  let newCart = cart.filter((item) => {
    return item.invoiceID !== cartItem.invoiceID && item.controlInvoicesRequiredFirst.includes(cartItem.invoiceID) === false;
  });

  let invoiceDependencyRemoved = ((cart.length - newCart.length) >= 2) ? true : false;
  // console.log("new cart", newCart);

  

  dispatch({
    type: "remove_from_cart",
    payload: { shoppingCart: newCart, invoices, accountNumbers, owners, address1, address2, city, state, zipcode, invoiceDependencyRemoved : invoiceDependencyRemoved},
  });
};

const setCartVisible = (dispatch) => async (visible) => {
  dispatch({
    type: "set_cart_visible",
    payload: visible,
  });
};

const setInvoiceDependencyRemoved = (dispatch) => async (invoiceDependencyRemoved) => {
  dispatch({
    type: "set_invoice_dependency_removed",
    payload: invoiceDependencyRemoved,
  });
};



export const { Provider, Context } = createDataContext(
  reducer,
  {
    addToCart,
    removeFromCart,
    setCartVisible,
    setInvoiceDependencyRemoved,
  },
  {
    shoppingCart: [],
    invoices: [],
    cartVisible: false,
    total: 0,
    invoiceDependencyRemoved: false,
    accountNumbers: [],
    owners: [],
    address1: [],
    address2: [],
    city: [],
    state: [],
    zipcode: [],
    applyInvoicePayment : []
  }
);
